import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/RootReducer';
import { reduxFirestore, getFirestore } from "redux-firestore";
import { getFirebase } from "react-redux-firebase";
import fbConfig from './config'



export default function configureStore() {
    return createStore(
        rootReducer,
        compose(
            applyMiddleware(thunk.withExtraArgument({ getFirestore, getFirebase })),
            reduxFirestore(fbConfig)
          )
    );
}
